module.exports = __webpack_public_path__ + "static/media/horse-head.c53455e1.svg";